import HTMLElement from '../html-element/HTMLElement.js';
/**
 * HTMLBRElement
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLBRElement
 */
export default class HTMLBRElement extends HTMLElement {}
